import axios from 'axios';


const url = process.env.REACT_APP_BASE_API_URL;

export const vereditoUsuarioImport = async (reaId) => {  
  const headers = { 'Content-Type': 'application/json'};
  return await axios.get(url + '/v1/vereditousuario/importitems/' + reaId, {headers});
}


export const vereditoUsuarioUpdate = async (vu) => {  
  console.log(vu);
  const headers = { 'Content-Type': 'application/json'};
  return await axios.put(url + '/v1/vereditousuario/update', vu, {headers});
}

export const vereditoUsuarioUpdateDownload = async (vu) => {  
  console.log(vu);
  const headers = { 'Content-Type': 'application/json'};
  return await axios.put(url + '/v1/vereditousuario/updatedownload', vu, {headers});
}


export const vereditoUsuarioFindByConIdCovIdVeuId = async (vu) => {  
  console.log(vu);
  const headers = { 'Content-Type': 'application/json'};
  return await axios.get(url + '/v1/vereditousuario/findbyconidcovidveuid/' + vu.con_id + '/'+ vu.cov_id + '/' + vu.veu_id, {headers});
}

export const vereditoUsuarioFindByConIdCovIdSupValid = async (vu) => {  
  console.log(vu);
  const headers = { 'Content-Type': 'application/json'};
  return await axios.get(url + '/v1/vereditousuario/findbyconidcovidsupvalid/' + vu.con_id + '/'+ vu.cov_id + '/' + vu.veu_id, {headers});
}

